import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true }) || [];
  return (
    <div className="legal-page">
      <div className="container">
        <div className="header-block">
          <h1>{t('privacy.title')}</h1>
          <span className="updated">{t('privacy.updated')}</span>
        </div>
        <div className="legal-body">
          {Array.isArray(sections) && sections.map((s, i) => (
            <div key={i}>
              <h2>{s.h}</h2>
              <p>{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
